module.exports = __webpack_public_path__ + "img/6_004.d54146ae.webp";